<template>
  <div class="entryWithPageContianer">
    <div class="entryHeader">
      <div class="title">
        <p>{{systemInfo.name}}</p>
        <div v-if="systemInfo.subTitle">{{systemInfo.subTitle}}</div>
      </div>
      <div class="entryHeaderRight">
        <div class="userInfo">{{userInfo.name}}，欢迎使用！</div>
        <div @click="goSelf()" class="backSelf" v-if="runAsOther">
          <div class="dropdownMenuName">
            <Icon type="md-swap"></Icon>返回
          </div>
        </div>
        <div class="logout">
          <!-- <Tooltip size='small' content='退出' transfor> -->
          <Icon @click="logout" class="logout" type="md-power" />
          <!-- </Tooltip> -->
        </div>
      </div>
    </div>
    <div class="swiperMain">
      <div class="pageEntry">
        <Carousel
          :autoplay="false"
          dots="none"
          style="width: 100%;"
          v-if="userEntries.length > partNum"
        >
          <CarouselItem
            :key="idex"
            class="entryItemContianer"
            v-for="idex in parseInt(userEntries.length / partNum) + 1"
          >
            <div class="entryItemLine">
              <template v-for="subInx in partNum">
                <div
                  :key="subInx+'-index'"
                  @click="toEntry(userEntries[(idex -1 )*partNum + (subInx - 1)])"
                  class="entryItem"
                  v-if="((idex -1 )*partNum + subInx) <= userEntries.length"
                >
                  <div class="entryIconBg">
                    <img
                      :onerror="onerrorIcon"
                      :src="userEntries[(idex -1 )*partNum + (subInx - 1)].iconPathMock"
                      class="entryIcon"
                    />
                  </div>
                  <p class="entryName">{{userEntries[(idex -1 )*partNum + (subInx - 1)].name}}</p>
                </div>
              </template>
            </div>
          </CarouselItem>
        </Carousel>
        <div class="entryItemLine" v-else>
          <div
            :key="item.code"
            @click="toEntry(item)"
            class="entryItem"
            v-for="item in userEntries"
          >
            <div class="entryIconBg">
              <img :src="item.iconPathMock" @error="onerrorIcon" class="entryIcon" />
            </div>
            <p class="entryName">{{item.name}}</p>
          </div>
        </div>
      </div>
      <div class="configEntry">
        <div :key="item.code" class="configEntryItem" v-for="item in configEntry">
          <div @click="toEntry(item)" class="entryIconBg">
            <img :src="item.configPathMock" @error="onerrorLogo" class="entryIcon" />
          </div>
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapActions, mapState } from 'vuex'
export default {
  name: 'entry',
  data () {
    return {
      partNum: 4,
      loginForm: {},
      projectInfo: {},
      logoIcon: require('@/assets/static/images/config.png'),
      configIcon: require('@/assets/static/images/icon.png'),
    }
  },
  computed: {
    systemInfo: function () {
      return this.$store.getters['systemInfo/systemInfo'] || {}
    },
    runAsOther: function () {
      return this.$store.getters['userInfo/runAsOther'] || false
    },

    userEntries: function () {
      let entries = Object.assign([], this.$store.getters['menuInfo/userEntries'] || [])
      return entries.filter(element => {
        if (element.icon) {
          element.iconPathMock = element.icon
        } else {
          element.iconPathMock = this.$common.basePath + "static/images/icon.png"
        }
        return element.isConfig != true
      })
    },
    configEntry: function () {
      let entries = Object.assign([], this.$store.getters['menuInfo/userEntries'] || [])
      return entries.filter(element => {
        if (element.icon) {
          element.configPathMock = element.icon
        } else {
          element.configPathMock = this.$common.basePath + "static/images/config.png"
        }
        return element.isConfig == true
      })
    },
    userInfo: function () {
      return this.$store.getters['userInfo/user'] || {}
    },
    entryMenus: function () {
      return this.$store.getters['menuInfo/entryMenus'] || {}
    },
  },
  methods: {
    onerrorLogo: function (e) {
      e.target.src = this.logoIcon
      e.target.onerror = null
    },
    onerrorIcon: function (e) {
      e.target.src = this.configIcon//data中的图片
      e.target.onerror = null
    },
    toEntry: function (entry) {
      if (entry.isExtraLink) {
        //若外链接 直接跳转
        window.open(entry.path, '_' + entry.pageOpenType)
      } else {
        this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'entryCode', value: entry.code })
        // 有子菜单 默认跳转第一个 
        let defaultUrl = this.$store.getters['userInfo/defaultUrl']
        if (defaultUrl) {
          this.$router.push({ path: defaultUrl })
        } else if (Object.keys(this.entryMenus).length > 0) {
          let openMenu = this.entryMenus[Object.keys(this.entryMenus)[0]][0]
          if (openMenu.children && openMenu.children.length > 0) {
            this.$router.push({ name: openMenu.children[0].pathName })
          } else {
            let pathName = openMenu.pathName
            this.$router.push({ name: pathName })
          }
        } else {
          // this.$router.push({name: entry.code + 'Entry'});
          this.$router.push({ path: '/unAuthorized' })
          this.$Message.warning("请通知管理员分配菜单权限！")
        }
      }
    },
    logout: function () {
      this.$bus.$emit('logout', true)
    },
    // 返回本身账号
    goSelf: function () {
      this.$bus.$emit('backSelf')
    },
    loadUserEntries: function (needChange) {
      console.log("loadUserEntries...")
      let that = this
      that.$axios.post(this.$apis.systemManager.userManager.getUserEntries).then(res => {
        if (res.success) {
          //入口
          let projectEntries = res.result.projectEntries || []
          this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'userEntries', value: projectEntries })
          if (projectEntries.length == 0) {
            that.$Message.warning("尚未分配入入口权限，请联系管理员处理！")
          }
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error('加载用户入口信息失败！')
      })
    },
  },
  beforeMount () {
    this.loadUserEntries()
  }
}
</script>
<style lang='less'>
@import './static/entryWithPage/index.less';
</style>